import styled from 'styled-components';

import { theme } from '../layout/theme';
import { size } from '../layout/helpers';

export const Hero = styled.div`
  overflow: hidden;
  ${theme.screens.Md} {
    position: relative;
    display: flex;
    align-items: stretch;

    &.narrow {
      margin: 0 auto;
      max-width: ${theme.distances.containerMaxWidth};
      padding-left: ${theme.distances.containerGutterMd};
      padding-right: ${theme.distances.containerGutterMd};

      &.in-panel {
        padding-left: ${theme.distances.containerGutter};
        padding-right: ${theme.distances.containerGutter};
      }
    }
  }
`;

export const ImageWrapper = styled.div`
  position: relative;
  min-height: ${size(4)};
  background-color: ${theme.colors.bg.accent};

  ${theme.screens.Md} {
    flex: 1 1 auto;
    align-self: flex-start;

    &:not(.content-pos-center):not(.in-panel) {
      img {
        min-height: 400px;
        object-fit: cover;
      }
    }
  }
`;

type ImagePlaceholderProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
> & {
  ratio?: number;
};

export const ImagePlaceholder = styled.div<ImagePlaceholderProps>`
  height: 0;
  padding-bottom: ${(props) => (props.ratio ? `${props.ratio}%` : '66.66666667%')};
`;

export const ImageLink = styled.a`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${theme.colors.bg.alt};
  color: ${theme.colors.text.onAlt};
  padding: ${size(4)} ${size(2)};
  text-align: center;

  strong {
    font-weight: 500;
  }

  ${theme.screens.LtMd} {
    margin: ${size(-2)} ${size(2)} ${size(2)};
    position: relative;

    .product-grid & {
      margin: ${size(-2)} ${size(1)} ${size(2)};
    }
  }

  ${theme.screens.Md} {
    flex-shrink: 0;
    justify-content: center;
    width: 30%;
    max-width: 30%;
    padding: ${size(4)};
    margin-left: -1px;

    &.pos-left {
      order: -1;
      margin-right: -1px;
      margin-left: 0;
    }

    &.pos-center {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 40%;
      max-width: 680px;
      padding: ${size(8)};
      margin-left: 0;
    }
  }
`;

export const Heading = styled.h2`
  margin: 0;
  font-size: 30px;
  line-height: 1;
  font-family: ${theme.font.family.brand};
  font-weight: 700;

  &.font-size-small {
    font-size: 26px;
  }

  &.font-size-large {
    font-size: 42px;
  }

  &.font-size-extralarge {
    font-size: 64px;
  }

  &.italic {
    font-style: italic;
  }

  ${theme.screens.Lg} {
    font-size: 52px;

    &.font-size-small {
      font-size: 36px;
    }

    &.font-size-large {
      font-size: 64px;
    }

    &.font-size-extralarge {
      font-size: 80px;
    }
  }
`;

export const Description = styled.div`
  margin-top: ${size(2)};
  font-size: 20px;
  line-height: 1.2;
  font-family: 'Bulldog Mio', 'Source Sans Pro', sans-serif;
  font-weight: 400;

  > * {
    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: ${size(1)};
    }
  }

  p,
  ul,
  ol,
  h2,
  h3,
  h4 {
    margin: 1rem 0;
  }

  ul,
  ol {
    text-align: left;
  }
`;

export const ActionList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  list-style: none;
  padding: 0;
  margin: ${size(-0.5)};
  margin-top: ${size(2)};
`;

export const ActionItem = styled.li`
  padding: ${size(0.5)};
`;

export const Countdown = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: ${theme.colors.text.onColor};
  z-index: 1;
`;

export const Products = styled.div`
  ${theme.screens.Md} {
    margin-top: ${size(2)};
  }
`;

export const ProductsFooter = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${size(2)};
`;
